module.exports = __webpack_public_path__ + "img/takein.81e2ed8f.svg";